import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Material" }

import { secondToString } from '@/utils/date-format'
import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import { Excel } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'
import { reactive, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

initEmptyParam()
const store = useStore()
const userInfo = store.state.login.userInfo
let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    duration: 0,
    callCounts: 0,
    timeRange: 'today',
    callDate: [getBeforeDate('today'), getBeforeDate('today')],
    callType: 'meeting_voice_call',
    usedBy: userInfo.realName
  }
} else {
  queryParam.value = {
    duration: 0,
    callCounts: 0,
    timeRange: 'today',
    callDate: [getBeforeDate('today'), getBeforeDate('today')],
    callType: 'meeting_voice_call'
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const getUsedBy = async () => {
  let userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const userOptions = userList.map((item: any) => {
    return {
      title: item.userName,
      value: item.userName
    }
  })
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userOptions
}
getUsedBy()

const getGroupList = async () => {
  let groupData = await getListData(
    '/main/enterpriseWechat/dingDept/getGroupList',
    {}
  )
  const groupId = searchFormConfig.formItems.find(
    (item) => item.field === 'groupName'
  )
  groupId!.options = groupData.map((item: any) => {
    return { title: item.deptName, value: item.deptName }
  })
}
getGroupList()

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', formData.value)
}

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.corPid }
  })
}

getCompanyList()

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/voiceDetail/queryExportData', queryInfo)
}

const handleVoiceDetail = (item: any) => {
  getExportData().then((res) => {
    let customHeader = [
      '企业号',
      '账户ID',
      '名称',
      '使用人',
      '组',
      '岗位',
      '客户名称',
      '客户ID',
      '开始时间',
      '结束时间',
      '通话时长',
      '主叫/被叫'
    ]
    let header = [
      'corpName',
      'serveId',
      'serveName',
      'usedBy',
      'parentDeptName',
      'deptName',
      'customName',
      'customId',
      'msgTime',
      'endTime',
      'duration',
      'actionName'
    ]
    let exportData = []
    for (let i = 0; i < res.length; i++) {
      let item = res[i]
      item.customName = item.customName + '(' + item.remark + ')'
      item.msgTime = ts2str(item.msgTime * 1)

      if (item.endTime == null) {
        item.endTime = '-'
        item.duration = '-'
      } else {
        item.endTime = ts2str(item.endTime * 1000)
        item.duration =
          Math.floor(item.duration / 60) + '分' + (item.duration % 60) + '秒'
      }
      exportData.push(item)
    }
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '语音通话记录-' + filename,
      title: '语音通话记录-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const getOvertimeData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/voiceDetail/exportOvertimeData', queryInfo)
}

const handleOvertimeData = (item: any) => {
  getOvertimeData().then((res) => {
    let customHeader = [
      '组',
      '使用人',
      '记录数',
      '通话时长_分钟'
    ]
    let header = [
      'parentDeptName',
      'usedBy',
      'countNum',
      'duration'
    ]
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '加班通话汇总-' + filename,
      title: '加班通话汇总-' + filename,
      data: reactive(res),
      header,
      customHeader
    })
  })
}

const getWorktimeData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/voiceDetail/exportWorktimeData', queryInfo)
}

const handleWorktimeData = (item: any) => {
  getWorktimeData().then((res) => {
    let customHeader = [
      '组',
      '使用人',
      '记录数',
      '通话时长_分钟'
    ]
    let header = [
      'parentDeptName',
      'usedBy',
      'countNum',
      'duration'
    ]
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '工作时间通话汇总-' + filename,
      title: '工作时间通话汇总-' + filename,
      data: reactive(res),
      header,
      customHeader
    })
  })
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "voiceDetail",
      onVoiceDetail: handleVoiceDetail,
      onOvertimeData: handleOvertimeData,
      onWorktimeData: handleWorktimeData,
      onSortChange: handleSortChange
    }, {
      customName: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.customName +
            (scope.row.remark ? '(' + scope.row.remark + ')' : '')), 1)
      ]),
      beginTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatUnixTime(Number(scope.row.msgTime))), 1)
      ]),
      endTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(scope.row.endTime
            ? '-'
            : _ctx.$filters.formatUnixTime(Number(scope.row.endTime) * 1000)), 1)
      ]),
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(Number(scope.row.duration))), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})